enum LoanPayoutFigureMinimumTermInterestModeEnum {
    Auto = 'AUTO',
    Off = 'OFF',
}

export default LoanPayoutFigureMinimumTermInterestModeEnum;